import classnames from "classnames";
import React, { PureComponent, ReactNode } from "react";
import styled from "styled-components";

import theme from "../../../theme";
import Hyperlink from "../../Hyperlink";

import {
  Dot,
  VerticalStep,
  VerticalStepBar,
  VerticalStepName,
  VerticalWrapper,
} from "./components";

export type DotType = "dot" | "check" | "none";

interface IImageWrapperProps {
  imageWidth?: number;
}

const ImageWrapper = styled.div<IImageWrapperProps>`
  align-self: center;
  flex-shrink: 0;
  flex-grow: 0;
  width: ${({ imageWidth }: IImageWrapperProps): string =>
    imageWidth ? `${imageWidth}px` : "59px"};
  margin-right: ${theme.margins.marginBase};
  padding: ${theme.margins.paddingPage} 0;
  text-align: center;
  height: 107px;
`;

const Image = styled.img`
  max-height: 100%;
  margin: auto;
`;

export interface IStep {
  imageSrc?: string;
  label: string;
  productUrl?: string;
  subLabel?: string | ReactNode;
  price?: string;
}

export interface IProps {
  className?: string;
  dotType?: DotType;
  horizontalPadding?: number;
  imageWidth?: number;
  onClick?: () => void; // @TODO: add debounce or so
  onClickLink?: () => void;
  progressIndex: number;
  steps: IStep[];
}

type IDefaultProps = Required<Pick<IProps, "className">>;

class VerticalProgressBar extends PureComponent<IProps, {}, IDefaultProps> {
  public static defaultProps: IDefaultProps = {
    className: "",
  };

  public render(): ReactNode {
    const {
      className,
      dotType,
      imageWidth,
      onClick,
      onClickLink,
      progressIndex,
      steps,
    } = this.props;

    const selectedDotType: DotType = dotType !== undefined ? dotType : "dot";

    return (
      <VerticalWrapper
        onClick={onClick}
        className={className}
        horizontalPadding={this.props.horizontalPadding}
      >
        {steps.map((step: IStep, index: number) => (
          <VerticalStep
            key={`step-${index}`}
            className={classnames(
              progressIndex >= index ? "active" : "",
              progressIndex === index ? "last-active" : ""
            )}
          >
            <VerticalStepName
              price={step.price}
              label={step.label}
              subLabel={step.subLabel}
              productUrl={step.productUrl}
              onClick={onClickLink}
            />
            {step.imageSrc && (
              <ImageWrapper imageWidth={imageWidth}>
                {step.productUrl ? (
                  <Hyperlink to={step.productUrl} onClick={onClickLink}>
                    <Image src={step.imageSrc} alt={step.label} />
                  </Hyperlink>
                ) : (
                  <Image src={step.imageSrc} alt={step.label} />
                )}
              </ImageWrapper>
            )}
            {dotType !== "none" && (
              <VerticalStepBar>
                <Dot dotType={selectedDotType} />
              </VerticalStepBar>
            )}
          </VerticalStep>
        ))}
      </VerticalWrapper>
    );
  }
}

export default VerticalProgressBar;
